import { render, staticRenderFns } from "./lembrete.vue?vue&type=template&id=355d7b48"
import script from "./lembrete.vue?vue&type=script&lang=js"
export * from "./lembrete.vue?vue&type=script&lang=js"
import style0 from "./lembrete.vue?vue&type=style&index=0&id=355d7b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports